import type { BackendPlan, Pharmacy, PharmacyDTO, PharmacyPlan } from './types';

const PHARMABEST = 'pharmabest';
const PHARMABEST_ES = 'pharmabest-es';
const PHARMABEST_GROUPS = new Set([PHARMABEST, PHARMABEST_ES]);

const PLANS_MAP: Record<BackendPlan, PharmacyPlan> = {
  NO_FEATURE: 'NO_FEATURE',
  ZERO: 'NO_FEATURE',
  ONE: 'ESSENTIAL',
  NEWS: 'ESSENTIAL',
  SNC: 'PRO',
  CNC: 'EXPERT',
};

const interpretBackendPlan = (backendPlan?: BackendPlan): PharmacyPlan => {
  return backendPlan ? PLANS_MAP[backendPlan] : 'NO_FEATURE';
};

const interpretFeaturesToPlan = (features: string[]): PharmacyPlan => {
  if (features.includes('SHOP') || features.includes('PARAPHARMACY_SHOP')) {
    return 'EXPERT';
  }
  if (features.includes('PATIENT_FILE')) {
    return 'PRO';
  }

  return 'ESSENTIAL';
};

export const mapPharmacyDTOToPharmacy = (pharmacy: PharmacyDTO): Pharmacy => {
  const plan: PharmacyPlan =
    interpretBackendPlan(pharmacy.plan) ||
    interpretFeaturesToPlan(pharmacy.features);

  return {
    ...pharmacy,
    isPharmabest: PHARMABEST_GROUPS.has(pharmacy?.groupId || ''),
    isPharmabestEs: (pharmacy?.groupId || '') === PHARMABEST_ES,
    pharmacyPlan: plan,
  };
};
